<script>
export default {
  name: 'RedirectView',
  created () {
    const current = new URL(window.location.href)
    const params = current.searchParams
    let closeUrl = params.get('closeurl')
    if (!closeUrl) {
      const match = (window.location.search || '').match(/[?&]closeurl=([^]*)/)
      closeUrl = match && match[1]
    }
    if (!closeUrl) return
    try {
      closeUrl = decodeURIComponent(closeUrl)
    } catch (e) {
      // Keep raw closeUrl when decode fails.
    }
    try {
      const target = new URL(closeUrl)
      const keys = ['game', 'rgsId', 'page']
      keys.forEach((key) => {
        const value = params.get(key)
        if (value && !target.searchParams.has(key)) {
          target.searchParams.set(key, value)
        }
      })
      closeUrl = target.toString()
    } catch (e) {
      // Keep original closeUrl if parsing fails.
    }
    window.top.location.href = closeUrl
  }
}
</script>
